// eslint-disable-next-line consistent-return,func-names
export default function (context) {
  const isPc = context.$ua.deviceType() === 'pc';
  context.store.commit('device/setUserDevice', isPc);
}
